import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../helpers/axios';
import { Grid, Card, CardContent, CardHeader, CardActions, IconButton, Button, Box, Typography, FormControl, InputLabel, Input, TextField, OutlinedInput, InputAdornment, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Paper, Checkbox, Select, MenuItem, Backdrop, CircularProgress, Divider } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, CheckOutlined, CloseOutlined, FormatListNumberedRtlTwoTone } from '@mui/icons-material';

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    profile_details: any;
    editName: boolean;
    name: string;
    editPhone: boolean;
    phone: string;
    editEmail: boolean;
    email: string;
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

class Profile extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            profile_details: {},
            editName: false,
            name: '',
            editPhone: false,
            phone: '',
            editEmail: false,
            email: '',
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        }
    }

    public componentDidMount(): void {
        this.fetchProfileDetails();
    }

    public fetchProfileDetails() {
        this.setState({ showLoader: false });
        axios.get(`profile`).then(response => {
            this.setState({ showLoader: false });
            let data = response.data.data;
            if (response.data.success) {
                this.setState({ profile_details: data.user });
            } else {
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            }
        });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleUpdateProfileDetails = (key: string, value: any) => {
            this.setState({ showLoader: true });
            let data: any = {};
            data[key] = value;
            axios.post(`updateProfile`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showLoader: false });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchProfileDetails();
                } else {
                    this.setState({ showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        };

        const handleChangePassword = () => {
            this.setState({ showLoader: true });
            let data: any = {
                Password: this.state.oldPassword,
                nPassword: this.state.newPassword
            };
            axios.post(`changePassword`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showLoader: false, oldPassword: '', newPassword: '', confirmPassword: '' });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                } else {
                    this.setState({ showLoader: false, oldPassword: '', newPassword: '', confirmPassword: '' });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false, oldPassword: '', newPassword: '', confirmPassword: '' });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        };

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme:any) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={t("Details")}
                                className="text-left"
                            />
                            <CardContent>
                                <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                                        <TableBody className="customCardDetails">
                                            <TableRow
                                                key="name"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        {t("Name")}
                                                    </Typography>
                                                </TableCell>
                                                {
                                                    (!this.state.editName) &&
                                                    <TableCell>
                                                        {this.state.profile_details.name}
                                                        <IconButton className="customIconButton" aria-label="change name" component="span" onClick={() => this.setState({ editName: true, name: this.state.profile_details.name })}>
                                                            <EditOutlined />
                                                        </IconButton>
                                                    </TableCell>
                                                }
                                                {
                                                    (this.state.editName) &&
                                                    <TableCell>
                                                        <FormControl fullWidth={true}>
                                                            <InputLabel htmlFor="name">{t("Name")}</InputLabel>
                                                            <OutlinedInput
                                                                id="name"
                                                                value={this.state.name}
                                                                onChange={(e: any) => this.setState({ name: e.target.value })}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="update name"
                                                                            onClick={() => {
                                                                                handleUpdateProfileDetails('name', this.state.name);
                                                                                this.setState({ editName: false, name: '' })
                                                                            }}
                                                                            edge="end"
                                                                            size="large"
                                                                            className="customIconButton"
                                                                        >
                                                                            <CheckOutlined fontSize="large" />
                                                                        </IconButton>
                                                                        <Divider orientation="vertical" />
                                                                        <IconButton
                                                                            aria-label="cancel edit name"
                                                                            onClick={() => this.setState({ editName: false, name: '' })}
                                                                            edge="end"
                                                                            size="large"
                                                                            color="warning"
                                                                        >
                                                                            <CloseOutlined fontSize="inherit" />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label={t("Name")}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                            <TableRow
                                                key="email"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        {t("Email")}
                                                    </Typography>
                                                </TableCell>
                                                {
                                                    (!this.state.editEmail) &&
                                                    <TableCell>
                                                        {this.state.profile_details.email}
                                                        <IconButton className="customIconButton" aria-label="change email" component="span" onClick={() => this.setState({ editEmail: true, email: this.state.profile_details.email })}>
                                                            <EditOutlined />
                                                        </IconButton>
                                                    </TableCell>
                                                }
                                                {
                                                    (this.state.editEmail) &&
                                                    <TableCell>
                                                        <FormControl fullWidth={true}>
                                                            <InputLabel htmlFor="email">{t("Email")}</InputLabel>
                                                            <OutlinedInput
                                                                id="email"
                                                                value={this.state.email}
                                                                onChange={(e: any) => this.setState({ email: e.target.value })}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="update email"
                                                                            onClick={() => {
                                                                                handleUpdateProfileDetails('email', this.state.email);
                                                                                this.setState({ editEmail: false, email: '' })
                                                                            }}
                                                                            edge="end"
                                                                            size="large"
                                                                            className="customIconButton"
                                                                        >
                                                                            <CheckOutlined fontSize="large" />
                                                                        </IconButton>
                                                                        <Divider orientation="vertical" />
                                                                        <IconButton
                                                                            aria-label="cancel edit email"
                                                                            onClick={() => this.setState({ editEmail: false, email: '' })}
                                                                            edge="end"
                                                                            size="large"
                                                                            color="warning"
                                                                        >
                                                                            <CloseOutlined fontSize="inherit" />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label={t("Email")}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                            <TableRow
                                                key="phone"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        {t("Phone")}
                                                    </Typography>
                                                </TableCell>
                                                {
                                                    (!this.state.editPhone) &&
                                                    <TableCell>
                                                        {this.state.profile_details.phone}
                                                        <IconButton className="customIconButton" aria-label="change phone" component="span" onClick={() => this.setState({ editPhone: true, phone: this.state.profile_details.phone })}>
                                                            <EditOutlined />
                                                        </IconButton>
                                                    </TableCell>
                                                }
                                                {
                                                    (this.state.editPhone) &&
                                                    <TableCell>
                                                        <FormControl fullWidth={true}>
                                                            <InputLabel htmlFor="phone">{t("Phone")}</InputLabel>
                                                            <OutlinedInput
                                                                id="phone"
                                                                value={this.state.phone}
                                                                onChange={(e: any) => this.setState({ phone: e.target.value })}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="update phone"
                                                                            onClick={() => {
                                                                                handleUpdateProfileDetails('phone', this.state.phone);
                                                                                this.setState({ editPhone: false, phone: '' })
                                                                            }}
                                                                            edge="end"
                                                                            size="large"
                                                                            className="customIconButton"
                                                                        >
                                                                            <CheckOutlined fontSize="large" />
                                                                        </IconButton>
                                                                        <Divider orientation="vertical" />
                                                                        <IconButton
                                                                            aria-label="cancel edit phone"
                                                                            onClick={() => this.setState({ editPhone: false, phone: '' })}
                                                                            edge="end"
                                                                            size="large"
                                                                            color="warning"
                                                                        >
                                                                            <CloseOutlined fontSize="inherit" />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label={t("Phone")}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                            <TableRow
                                                key="account_type"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0} }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div" className='detailsTitle'>
                                                        {t("AccountType")}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    {/* {this.state.profile_details.role == "datalabs_admin"? "Admin": ""} */}
                                                    {this.state.profile_details.role === "datalabs_admin" ? "Admin" :
                                                        this.state.profile_details.role === "warehouse_manager" ? "Warehouse Manager" :
                                                        this.state.profile_details.role === "bad_bag_manager" ? "Bad Bag Manager" :
                                                    ""}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={t("ChangePassword")}
                                className="text-left"
                            />
                            <CardContent>
                                <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                                        <TableBody className="customCardDetails">
                                            <TableRow
                                                key="old-password"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div">
                                                        {t("OldPassword")}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell size='medium'>
                                                    <TextField
                                                        id="old-password"
                                                        type="password"
                                                        label={t("OldPassword")}
                                                        variant="outlined"
                                                        InputProps={{
                                                            inputProps: { autoComplete: "off" }
                                                        }}
                                                        fullWidth={true}
                                                        value={this.state.oldPassword}
                                                        required
                                                        onChange={(e: any) => this.setState({ oldPassword: e.target.value })}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="new-password"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div">
                                                        {t("NewPassword")}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell size='medium'>
                                                    <TextField
                                                        id="new-password"
                                                        type="password"
                                                        label={t("NewPassword")}
                                                        variant="outlined"
                                                        InputProps={{
                                                            inputProps: { autoComplete: "off" }
                                                        }}
                                                        fullWidth={true}
                                                        value={this.state.newPassword}
                                                        required
                                                        onChange={(e: any) => this.setState({ newPassword: e.target.value })}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow
                                                key="confirm-password"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    <Typography variant="subtitle1" component="div">
                                                        {t("ConfirmPassword")}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell size='medium'>
                                                    <TextField
                                                        id="confirm-password"
                                                        type="password"
                                                        label={t("ConfirmPassword")}
                                                        variant="outlined"
                                                        InputProps={{
                                                            inputProps: { autoComplete: "off" }
                                                        }}
                                                        fullWidth={true}
                                                        value={this.state.confirmPassword}
                                                        required
                                                        onChange={(e: any) => this.setState({ confirmPassword: e.target.value })}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                            <CardActions sx={{ justifyContent: 'center' }}>
                                <Button variant='contained' className='makeCustomer' disabled={(this.state.oldPassword && this.state.newPassword && this.state.confirmPassword && (this.state.newPassword == this.state.confirmPassword)) ? false : true} onClick={() => handleChangePassword()}>{t("ChangePassword")}</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </div >
        )
    }
}

export default withRouter(withTranslation()(Profile))